import React from "react";
import GlobalContact from "../Components/GlobalContact";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
const { t } = useTranslation();
  return (
    <div className="bg-cp-black">
      <div className='min-h-[calc(100vh-140px)] h-auto md:bg-[url("../public/Images/Contact_Image.jpg")] bg-cover  bg-no-repeat relative  md:mt-0 overflow-hidden max-w-[1920px] m-auto'>
        <div className="bg-cp-green absolute inset-0 opacity-30 md:block xs:hidden"></div>
        <div className="w-full flex justify-center items-center">
        <div className="flex justify-center items-center  w-[80%]  xs:flex-col-reverse md:flex-row-reverse">
          <GlobalContact />
          {/* <div className="md:w-[42%] xs:w-full xs:p-0 xs:py-14 flex flex-col gap-8 bg-cp-black/50 z-30 md:p-10">
            <h2 className="text-cp-white xs:text-3xl md:text-4xl font-bold text-center">{t("getintouch")}</h2>
            <p className="text-cp-white text-xl font-bold [text-shadow:3px_3px_8px_rgba(0,0,0,0.7)] xs:text-center md:text-left">{t("contactdes")}</p>
             <section className="text-cp-white flex  items-center gap-5 text-xl font-bold [text-shadow:3px_3px_8px_rgba(0,0,0,0.7)]">
              <img src="https://media.bbf-bike.de/shop/documents/websites/panther/images/email.png" className="h-8 w-8 object-contain"/>
              <a href="mailto:info@cp-cycleparts.de">info@cp-cycleparts.de</a>
             </section>
             <section className="text-cp-white flex  items-center gap-5 text-xl font-bold [text-shadow:3px_3px_8px_rgba(0,0,0,0.7)]">
              <img src="https://media.bbf-bike.de/shop/documents/websites/panther/images/telephone.png" className="h-8 w-8 object-contain"/>
              <a>+49 (0) 3342.354.325</a>
             </section>
          </div> */}
        </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
